import { render, staticRenderFns } from "./TrendList.vue?vue&type=template&id=6c8f9280&scoped=true&"
import script from "./TrendList.vue?vue&type=script&lang=js&"
export * from "./TrendList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f9280",
  null
  
)

export default component.exports